<div *ngIf="activePlan$ | async as product" class="plan-banner">
  <dgx-components-grid-container>
    <dgx-components-grid-row>
      <dgx-components-grid-column [xs]="12" [lg]="12">
        <dgx-components-icon [icon]="'check-circle'" [size]="'md'" />
        <strong>Seeing content for:</strong
        ><span class="appliance-name"
          >{{ product.item.manufacturer | titlecase }}
          {{ product.item.code_description | titlecase }}
        </span>
        <span>Plan number: {{ product.plan_number }}</span>
        <a (click)="togglePlanSelection.emit()" data-testid="change-product"
          >Change <span class="long-link">Product</span>
          <dgx-components-icon [icon]="'arrow-right'" [size]="'md'"
        /></a>
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</div>
